import { Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { TaskDetailsViewSettingsComponent } from '@app/components/task/task-splitview-list/task-details-content/task-details-view-settings.component';
import { TaskTypeSelectComponent } from '@app/components/task/task-state-selectors/task-type-select/task-type-select.component';
import { TaskType } from '@app/shared/types/models/task/task-type.model';
import { Task } from '@app/shared/types/models/task/task.model';
import { UiTextareaEditorComponent } from '@app/shared/ui/textarea-editor/ui-textarea-editor.component';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * @summary Task detail panel header — editable title, type select, and mobile toolbar actions.
 * On desktop the panel renders it twice: `identity` (type + number) in the header row and
 * `title` in the row below.
 * @selector proffeo-task-details-header
 */
@Component({
  selector: 'proffeo-task-details-header',
  templateUrl: './task-details-header.component.html',
  styleUrl: './task-details-header.component.scss',
  host: {
    class: 'block min-w-0 max-w-full'
  },
  imports: [
    MatIconModule,
    MatMenuModule,
    TaskTypeSelectComponent,
    TaskDetailsViewSettingsComponent,
    UiTextareaEditorComponent,
    TranslatePipe
  ]
})
export class TaskDetailsHeaderComponent {
  public readonly task = input.required<Task>();
  public readonly isMobile = input.required<boolean>();
  public readonly isNameEditing = input.required<boolean>();
  public readonly taskTypes = input.required<TaskType[]>();
  public readonly maxTaskNameLength = input.required<number>();
  public readonly taskActionsMenu = input.required<MatMenu>();
  /** @summary Desktop part to render: type + number (header row) or the editable title. */
  public readonly desktopSection = input<'identity' | 'title'>('identity');

  public readonly taskNameChanged = output<string>();
  public readonly nameEditCancelled = output<void>();
  public readonly nameEditRequested = output<void>();
  public readonly taskTypeSelected = output<TaskType>();
  public readonly closeRequested = output<void>();
}
